import {useEffect} from "react";

/**
 * Hook to poll project list refresh every `intervalMs` milliseconds.
 */
export const useProjectPolling = (
  refreshProjectsSilently: () => Promise<void>,
  intervalMs: number = 60000
): void => {
  useEffect(() => {
    const interval = setInterval(() => {
      refreshProjectsSilently().catch(console.error);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [refreshProjectsSilently, intervalMs]);
};
